import formStyle from '@/styles/modules/form.module.scss';
import clsx from 'clsx';
import FormLabel from '../../form/FormLabel/FormLabel';
import styles from './FormValue.module.scss';

type Props = {
  children: React.ReactNode;
  label: string;
  inline?: boolean;
};

function FormValue({ children, label, inline = false }: Props) {
  const classes = clsx({
    [formStyle.formComponentStyle]: true,
    [styles.inline]: inline,
  });
  return (
    <div className={classes}>
      {/* ラベル */}
      {label && <FormLabel>{label}</FormLabel>}
      {/* フィールド */}
      <div className={styles.fieldWrapper}>{children}</div>
    </div>
  );
}
export default FormValue;
